import { SET_TEAMS } from '../Constants/actionTypes';

export const setTeamsContext = (payload) => (dispatch) => {
  dispatch({
    type: SET_TEAMS,
    payload,
  });
};
